import {loadDetailContent} from "../detail";

export function agGridPrevRecord(event) {
	let selectedNodes = gridSettings.api.getSelectedNodes();
	if (selectedNodes && selectedNodes.length === 1) {
		let selectedNode = selectedNodes[0];
		window.gridSettings.api.forEachNodeAfterFilter((node) => {
			if (node.childIndex === (selectedNode.childIndex - 1)) {
				node.setSelected(true, true);
				loadDetailContent(node.data.id)
				return;
			}
		});
	}
}

export function agGridNextRecord(event) {
	let selectedNodes = gridSettings.api.getSelectedNodes();
	if (selectedNodes && selectedNodes.length === 1) {
		let selectedNode = selectedNodes[0];
		window.gridSettings.api.forEachNodeAfterFilter((node) => {
			if (node.childIndex === (selectedNode.childIndex + 1)) {
				node.setSelected(true, true);
				loadDetailContent(node.data.id)
				return;
			}
		});
	}
}
